// Which permission each dashboard page needs to be opened. Pages not listed
// (Home, Listen, Stations) are open to every logged-in account.
// The API enforces the same rules on the data; this just hides what a person
// can't use. See api/app/core/permissions.py.
const PAGE_PERMISSIONS: Record<string, string> = {
  "/media": "media.view",
  "/playlists": "playlists.view",
  "/schedule": "schedule.view",
  "/live": "live.view",
  "/statistics": "statistics.view",
  "/requests": "requests.view",
  "/monitoring": "monitoring.view",
  "/logs": "monitoring.view",
  "/settings": "settings.view",
  "/users": "users.view",
  "/website": "website.view",
};

export function permissionForPath(pathname: string): string | null {
  const first = "/" + (pathname.split("/")[1] ?? "");
  return PAGE_PERMISSIONS[first] ?? null;
}
